module.exports = __webpack_public_path__ + "static/img/405.12a8427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201029/405.jpg
// module id = 9dKF
// module chunks = 0